import { TCustomFilterDetails } from 'modules/_common/models';
import API from 'services/api';

export const getCustomFilterDetails = ({
  filterId,
}: {
  filterId: string | null | undefined;
}): Promise<TCustomFilterDetails> =>
  API.get(`/api/users/filters/${filterId}`)?.then(promise => promise?.data);
